import Vue from 'vue'

export const DashboardService = {
  dashboardDetails (params = []) {
    return Vue.axios.get('/dashboard', { params })
      .then((response) => response.data)
  },

  charts (params = []) {
    return Vue.axios.get('/dashboard/charts', { params })
      .then((response) => response.data)
  }
}
